import { useRecoilValue } from "recoil";
import { inventoryItemAdditionalState } from "../../utils/atoms/atoms";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { getInventoryItem } from "../../api/inventory";
import { InventoryEntryDetails } from "../../interfaces/app_types";

const AdditionalInfoModal = () => {
  const additionalItemId = useRecoilValue(inventoryItemAdditionalState);
  const { data: inventoryItem } = useQuery<InventoryEntryDetails>({
    queryKey: ["inventory-item-additional"],
  });

  const queryClient = useQueryClient();

  const additionalItemMutation = useMutation({
    mutationFn: () => {
      return getInventoryItem(additionalItemId);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["inventory-item-additional"], data);
    },
  });
  useEffect(() => {
    additionalItemMutation.mutate();
  }, [additionalItemId]);
  return (
    <div className="d-flex">
      <h5>{inventoryItem?.notes || "No Additional Information"}</h5>
    </div>
  );
};

export default AdditionalInfoModal;
